import { useFiltersContext } from '@openx/components-filters/lib/context/FiltersContext.tsx';
import isEqual from 'lodash/isEqual';
import { useMemo } from 'react';
import { useDealPrompt } from './useDealPrompt.ts';

type UseFilterChangeDetectionProps = {
  isPreview: boolean;
};

export const useFilterChangeDetection = ({ isPreview }: UseFilterChangeDetectionProps) => {
  const { criteria } = useFiltersContext();
  const {
    state: { lastSubmittedFilterCriteria },
  } = useDealPrompt();

  const isFiltersChanged = useMemo(() => {
    if (!isPreview) return false;

    const prevFilters = lastSubmittedFilterCriteria?.filters ?? {};
    const currentFilters = criteria?.filters ?? {};

    return !isEqual(prevFilters, currentFilters);
  }, [criteria?.filters, lastSubmittedFilterCriteria?.filters, isPreview]);

  return isFiltersChanged;
};
